// extracted by mini-css-extract-plugin
module.exports = {"actions":"AlisaTextField_actions__3Sqv3","accentLabel":"AlisaTextField_accentLabel__1BjbC"};